import barba from '@barba/core';

const barbaUpdateOnEnter = () => {
  barba.hooks.enter( ( data ) => {
    // barbaUpdateTitle( data );
    // barbaUpdateNavigation(data);
    barbaUpdateHtml( data );
    barbaUpdateClasses( data );
  } );
};

const barbaUpdateHtml = ( data ) => {
  const selectors = [
    '#wpadminbar',
    '#title-inner-wrapper',
    '#menu-primair',
    'title',
  ];

  const parser = new DOMParser();
  const dom = parser.parseFromString( data.next.html, 'text/html' );

  selectors.forEach( selector => {
    const source = dom.querySelector( selector );
    if(source) {
      const target = document.querySelector( selector );
      target.innerHTML = source.innerHTML;
    }
  } );
};

const barbaUpdateClasses = ( data ) => {
  const selectors = [
    'body',
  ];

  const parser = new DOMParser();
  const dom = parser.parseFromString( data.next.html, 'text/html' );

  selectors.forEach( selector => {
    const source = dom.querySelector( selector );
    const target = document.querySelector( selector );
    target.classList = source.classList;
  } );
};



export { barbaUpdateOnEnter };
